module.exports = __webpack_public_path__ + "static/media/How-to-Trade-In-a-Car-with-Negative-Equity.390b941d.jpg";